export const switchColors = {
  main: 'seaBlue.main',
  hover: 'seaBlue.40',
  offBg: 'sandstone.55', // on/off state of the switch
  offBgContrast: 'sandstone.45', // on/off state of the switch
  disabled: 'sandstone.main', // 79: the non-clickable state
  disabledBg: 'sandstone.95',
  green: 'landGreen.main',
  red: 'energyRed.main',
}
